import React from 'react';
import type { IconProps } from '../types';

/**
 * Isometric-cube icons for the MPR / 3D toolbar buttons.
 *
 * Shared cube geometry (24×24 view box):
 *   A top(12,3)  B right-top(20,7.5)  C front-center(12,12)  D left-top(4,7.5)
 *   E left-bot(4,16.5)  F front-bot(12,21)  G right-bot(20,16.5)
 *
 * Both icons draw with `currentColor`, so they pick up the toolbar's themed
 * (active / inactive) color automatically.
 */
const SILHOUETTE = 'M12 3 L20 7.5 L20 16.5 L12 21 L4 16.5 L4 7.5 Z';
const INTERNAL_EDGES = 'M4 7.5 L12 12 M20 7.5 L12 12 M12 12 L12 21';
const TOP_FACE = 'M12 3 L20 7.5 L12 12 L4 7.5 Z';
const LEFT_FACE = 'M4 7.5 L12 12 L12 21 L4 16.5 Z';
const RIGHT_FACE = 'M20 7.5 L12 12 L12 21 L20 16.5 Z';

/** MPR — multiplanar reconstruction: cube with the top plane highlighted. */
export const IconMprCube = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path
      d={TOP_FACE}
      fill="currentColor"
      fillOpacity="0.85"
      stroke="none"
    />
    <path d={SILHOUETTE} />
    <path d={INTERNAL_EDGES} />
  </svg>
);

/** 3D — volume rendering: a solid (all-faces shaded) cube. */
export const IconVolumeCube = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path
      d={TOP_FACE}
      fill="currentColor"
      fillOpacity="0.30"
      stroke="none"
    />
    <path
      d={LEFT_FACE}
      fill="currentColor"
      fillOpacity="0.16"
      stroke="none"
    />
    <path
      d={RIGHT_FACE}
      fill="currentColor"
      fillOpacity="0.22"
      stroke="none"
    />
    <path d={SILHOUETTE} />
    <path d={INTERNAL_EDGES} />
  </svg>
);

export default IconMprCube;
